import React from 'react';
export function AnnouncementBar() {
  return <aside className="w-full bg-brand-navy px-4 py-2 text-center text-white" data-id="element-16" data-mp="2tgqpao3xs0lk">
      <p className="text-[11px] font-semibold tracking-wide sm:text-xs" data-id="element-17" data-mp="om4xkg6zn3on">
        <span aria-hidden="true" data-id="element-18" data-mp="jtbqvmryll9x">🎵</span> Sofort-Download{' '}
        <span className="px-1 text-white/50" data-id="element-19" data-mp="jrqvxw1qg0bj">·</span> Klasse 1 bis 10{' '}
        <span className="px-1 text-white/50" data-id="element-20" data-mp="euqp3ix26tjd">·</span> Für alle Bundesländer
      </p>
    </aside>;
}